import { ChangeDetectionStrategy, Component, computed, inject, ResourceRef, signal, Signal } from '@angular/core';
import { rxResource, toSignal } from '@angular/core/rxjs-interop';
import { AlertComponent, PageHeaderComponent } from '@libs/common/components';
import { IconComponent } from '@libs/components/icons';
import type { SrmTicketListModel, SrmTicketModel } from '@libs/services/models';
import { NavItemModel } from '@libs/shared/models';
import { ViewportService } from '@libs/shared/services';
import { SrmService } from '../services';
import { SrmNavigationService } from '../srm-navigation.service';
import {
  SrmTicketListDesktopComponent,
  SrmTicketListDesktopSkeletonComponent,
  SrmTicketListMobileComponent,
  SrmTicketListMobileSkeletonComponent,
} from '../srm-ticket-list';

@Component({
  selector: 'ui-srm-overview',
  standalone: true,
  templateUrl: './srm-overview.component.html',
  styleUrls: ['./srm-overview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AlertComponent,
    IconComponent,
    PageHeaderComponent,
    SrmTicketListDesktopComponent,
    SrmTicketListMobileComponent,
    SrmTicketListMobileSkeletonComponent,
    SrmTicketListDesktopSkeletonComponent,
  ],
})
export class SrmOverviewComponent {
  public readonly srmService: SrmService = inject(SrmService);

  public readonly ticketsResource: ResourceRef<SrmTicketListModel | undefined> = rxResource({
    stream: () => this.srmService.getTickets(),
  });

  public readonly tickets: Signal<SrmTicketModel[]> = computed(() => this.ticketsResource.value()?.tickets ?? []);
  public readonly isDesktop: Signal<boolean> = toSignal(this.viewportService.isDesktop(), { initialValue: true });

  public srmCreateLink: Signal<NavItemModel> = signal({
    url: inject(SrmNavigationService).createLink(),
    target: '_self',
  });

  public constructor(
    private readonly viewportService: ViewportService,
  ) {
  }
}
